import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRecentCommentsByAll,
  getRecentCrmUserCommentsByAll,
} from "../actions/userAction";
import moment from "moment";

export default function OthersRecentComments(props) {
  const dispatch = useDispatch();
  const [contactId2, setContactId2] = useState(0);
  const guestCrm = JSON.parse(localStorage.getItem("guestCrm"));
  const guestAllComments = useSelector((state) => state.guestAllComments);
  const { loading, error, allRecentComments } = guestAllComments;

  useEffect(() => {
    // if (dataa == undefined || dataa.length == 0) {
    if (
      allRecentComments == undefined ||
      allRecentComments.length == 0 ||
      contactId2 !== props.contactId
    ) {
      if (guestCrm) {
        dispatch(getRecentCrmUserCommentsByAll(props.commentJson));
      } else {
        dispatch(getRecentCommentsByAll(props.commentJson));
      }

      setContactId2(props.contactId);
    } else {
    }
  }, [allRecentComments, props.contactId]);
  return (
    <>
      {loading ? (
        <>Loading ...</>
      ) : (
        <>
          {error ? (
            <>{error}</>
          ) : (
            <>
              {allRecentComments ? (
                <>
                  {allRecentComments.map((record) => (
                    <div className="card-body">
                      <div className="comment-content bg-white p-2">
                        <div className="d-flex flex-row user-info">
                          <img
                            className="rounded-circle"
                            src="assets/img/Deafult-user.png"
                            alt=""
                            width="40"
                          />
                          <div className="d-flex flex-column justify-content-start ml-2">
                            <span className="d-block font-weight-bold name">
                              {record?.First_Name || record.Guest_Name}
                            </span>
                            <span className="date text-black-50">
                              {record.Institute} -{" "}
                              {moment(record.Created_On).format()}
                            </span>
                          </div>
                        </div>
                        <div className="mt-2">
                          <p className="comment-text">{record.Comment}</p>
                          <div style={{display:"flex",justifyContent:"flex-end"}}>
                            {record?.Contact_Type ? (
                              <p className="contact_t">
                                {record?.Contact_Type}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </>
      )}
    </>
  );
}
